export default "__VITE_ASSET__DT$JpH6B__"